export default "__VITE_ASSET__BhAh0QiF__"